import { ProductTreeType } from './../products/products.component';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, of } from 'rxjs';
import { DiscoveredProduct, EnableProductResult, ProductComponent, ProductExt, ProductInstance, ProductInstanceRow, QuickAnalysisResult } from 'src/app/model/Product';
import { DataService } from 'src/app/service/data.service';
import { EventService } from 'src/app/service/event.service';
import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../controls/actionmenu/action-menu.component';
import { ColumnSort, ColumnType, DataTableColumn, DataTableRow } from '../controls/datatable/datatable.component';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Utils } from 'src/app/utils';
import { ProductDataType, ProductsComponent } from '../products/products.component';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { Events, WebsocketService, MsgPayLoad } from 'src/app/service/websocket.service';
import { Modal } from '../controls/modal/modal.service';
import { ActivityService } from 'src/app/service/activity.service';
import { ActivityCapabilities, ActivityCapabilitiesRequest, ActivityCapabilitiesType, ActivityTask, ActivityTaskType } from 'src/app/model/TaskStatus';
import { Agent } from 'src/app/model/Agent';
import { InstanceDetailsComponent } from '../dialogs/instance-details/instance-details.component';
import { Tab, TabColor } from '../controls/tabs/tabs.component';
import { ModalConfig } from '../controls/modal/modal-config';
import { ModalMessageComponent, ModalMessageType } from '../controls/modal-message/modal-message.component';
import { AgentService } from 'src/app/service/agent.service';
import { EnableProductComponent, EnableProductModalConfig } from '../dialogs/enable-product/enable-product.component';
import { SolutionService } from 'src/app/service/solution.service';

export enum EVENT_TARGET {
  ANALYZE_PRIMARY_SYSTEM,
  UPDATE_PRIMARY_SYSTEM
}
@Component({
    selector: 'app-products-component-details',
    templateUrl: './products-component-details.component.html',
    styleUrls: ['./products-component-details.component.css'],
    standalone: false
})
export class ProductsComponentDetailsComponent extends ProductsComponent implements OnInit {
  componentTableCols: DataTableColumn[];
  componentTableRows: DataTableRow[] = [];
  activeComponent:ProductComponent;
  activeProductInstances:Record<string, ProductInstance[]>;
  platform:string;
  activeProduct:ProductExt;
  foundProduct:ProductExt;
  title:string;
  currEnvId:number;
  isQuickAnalysisRequired = false;
  isMasterSystemSelected = true;
  isReload:boolean = false;
  isMasterSystemOnline:boolean = true;
  instancesTab = new Tab('instances-tab', $localize`Instances`, undefined, false);
  detailsTabs: Tab[] = [this.instancesTab];
  TabColor = TabColor;
  recountSelectedRow:boolean = false;
  pkgProdLogsCapabilities:ActivityCapabilities;
  adminSettingsCapabilities:ActivityCapabilities;
  isActivityCapabilitiesRequsted:boolean = false;
  isPkgProdLogsCapabilitiesReceived:boolean = false;
  isAdminSettingsCapabilitiesReceived:boolean = false;
  productCapabilities:ActivityCapabilities;
  enableCapabilities:ActivityCapabilities;
  quickAnalysisResult:QuickAnalysisResult;
  selectedSystem: any;
  activityCapabilityTarget: EVENT_TARGET;
  isEnvChange: boolean = false;
  masterSystemCounter: number = 0;
  isProductDetailsInProgress: boolean = false;
  productCapabilitiesRequestInProgress: boolean = false;

  constructor(protected eventService: EventService,
              protected authService:AuthenticationService,
              protected siService:SoftwareInventoryService,
              protected dataService:DataService,
              protected wsService: WebsocketService,
              protected router: Router,
              protected modal: Modal,
              protected activityService: ActivityService,
              protected route: ActivatedRoute,
              protected agentService: AgentService,
              protected solutionService: SolutionService) {
    super(eventService, authService, siService, dataService, wsService, router, modal, activityService, solutionService);
  }

  ngOnInit(): void {

    this.routeSubscription = this.route.params.subscribe(params => {
      this.productId = +params['productId'];
      this.setupid = params['setupid'];
      this.resetDefaults();
      this.setLoading();
    });

    this.dataSubscription = this.dataService.getData().subscribe((data: any) => {
      if (data && data.type == ProductDataType.AgentManifest) {
        this.isAgentManifestUpdating = data.isAgentManifestUpdating;
      } else if (data && (data.type == ProductDataType.General || data.type == ProductDataType.QuickAnalysis)) {
        this.proccessDataMessage(data);
      }
    });

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if (msg.eventType == Events.ActivityCapabilities) {
        if (this.isPendingTransaction(msg.headers.transactionId, true)) {
          this.activityCapabilities = JSON.parse(msg.body.msg);
          if (this.activityCapabilities.activityType == ActivityCapabilitiesType.PACKAGE_PRODUCT_LOGS) {
            this.proccessPackageLogsCapabilities(msg);
          } else if (this.activityCapabilities.activityType == ActivityCapabilitiesType.PRODUCT_CAPABILITIES) {
            this.processProductCapabilities();
          } else if (this.activityCapabilities.activityType == ActivityCapabilitiesType.ENABLE_PRODUCT) {
            this.processEnableProductCapabilities(msg);
          } else if (this.activityCapabilities.activityType == ActivityCapabilitiesType.ADMIN_SETTINGS) {
            this.processAdminSettingsCapabilities(msg);
          }
        }
      } else if (msg.eventType == Events.EnableProduct) {
        let enableProdResult: EnableProductResult = msg.body;
        this.isReload = enableProdResult.isEnabled;
      } else if (msg.eventType == Events.ManifestUpdateStarted) {
        this.isManifestUpdating = true;
      } else if (msg.eventType == Events.ManifestUpdateComplete) {
        this.reloadAfterManifestUpdate();
      } else if (msg.eventType == Events.AgentManifestComplete) {
        this.isAgentManifestUpdating = false;
        this.setLoading();
      }
    });
  }

  ngOnDestroy() {
    if (this.routeSubscription != undefined) {
      this.routeSubscription.unsubscribe();
    }
    if (this.dataSubscription != undefined) {
      this.dataSubscription.unsubscribe();
    }
    if (this.eventMessageSubscription != undefined) {
      this.eventMessageSubscription.unsubscribe();
    }
  }

  initPage(): void {
    if(this.productCapabilities.supportsHotfix){
      if(this.quickAnalysisResult != undefined){
        this.isQuickAnalysisRequired = this.quickAnalysisResult ? !this.quickAnalysisResult.isValid : !this.foundProduct.isQuickAnalysisValid;
        this.isReload = true;
      }else{
        this.isReload = false;
      }

      if(!this.isMasterSystemOnline){
        this.isReload = true;
      }
    }else{
      this.isQuickAnalysisRequired = false;
      this.isMasterSystemOnline = true;
      this.isMasterSystemSelected = true;
    }

    if(this.platform && this.isReload){
      this.isLoading = true;
    }else if(!this.isMasterSystemOnline){
      this.isLoading = false;
    }
  }

  setTableColumns(): void {
    if(this.productCapabilities.supportsCluster) {
      this.componentTableCols = Array<DataTableColumn>(
        new DataTableColumn("system", $localize`System`, ColumnType.STRING, true, "29", ColumnSort.DESC),
        new DataTableColumn("installPath", $localize`Install path`, ColumnType.STRING, false, "20"),
        new DataTableColumn("version", $localize`Version`, ColumnType.STRING, false, "10"),
        new DataTableColumn("platform", $localize`Platform`, ColumnType.STRING, false, "15"),
        new DataTableColumn("masterInstanceStatus", $localize`Primary system`, ColumnType.STATUSEXT, false, "13"),
        new DataTableColumn("agentStatus", $localize`Agent status`, ColumnType.STATUSEXT, false, "13")
      );
    } else {
      this.componentTableCols = Array<DataTableColumn>(
        new DataTableColumn("system", $localize`System`, ColumnType.STRING, true, "28", ColumnSort.DESC),
        new DataTableColumn("installPath", $localize`Install path`, ColumnType.STRING, false, "28"),
        new DataTableColumn("version", $localize`Version`, ColumnType.STRING, false, "10"),
        new DataTableColumn("platform", $localize`Platform`, ColumnType.STRING, false, "19"),
        new DataTableColumn("agentStatus", $localize`Agent status`, ColumnType.STATUSEXT, false, "15")
      );
    }
  }

  proccessDataMessage(data: any): void {
      this.solutionInfo = data.solutionInfo;
      this.isManifestUpdating = this.solutionInfo.manifestStatus.isUpdating;
      this.isEnvChange = this.currEnvId != undefined && this.currEnvId != this.solutionInfo.currentEnvironment.id;
      this.currEnvId = this.solutionInfo.currentEnvironment.id;
      this.isReload = this.isReload || this.isEnvChange;
      this.quickAnalysisResult = data.quickAnalysisResult;
      
      if(this.quickAnalysisResult != undefined){
        this.isQuickAnalysisRequired = this.quickAnalysisResult ? !this.quickAnalysisResult.isValid : !this.foundProduct.isQuickAnalysisValid;
      }

      const discoveredProductGroup: DiscoveredProduct[] = data.discoveredProductGroup;
      if (this.isEnvChange) {
        this.router.navigate(['products/overview']);
      } else {
        //no products are enabled
        if (discoveredProductGroup.length == 0) {
          this.router.navigate(['products/overview']);
        }

        if (this.foundProduct == undefined || this.isReload) {
          this.setLoading();
          //get platform
          for (let i = 0; i < discoveredProductGroup.length; i++) {
            let foundProd: ProductExt[] = (discoveredProductGroup[i].products.filter((prod: ProductExt) => {
              return prod.id == this.productId;
            }))
            if (foundProd.length > 0) {
              this.foundProduct = foundProd[0]
              this.platform = this.foundProduct.platform;
              this.getProductCapabilities(this.foundProduct.pluginId);
              break;
            }
          }
          this.isMasterSystemOnline = this.foundProduct.isMasterSystemOnline;

          this.setSystemStatus();
        } 

      }
  }

  processProductCapabilities(): void {
    this.productCapabilities = this.activityCapabilities;
    this.productCapabilitiesRequestInProgress = false;
    this.setTableColumns();
    if (!this.isProductDetailsInProgress) {
      this.getProductDetails();
    }
    this.initPage();
  }

  proccessPackageLogsCapabilities(msg: MsgPayLoad): void {
    //check if download log feature is supported
    this.isPkgProdLogsCapabilitiesReceived = true;
    if (this.activityCapabilities.ok) {
      this.pkgProdLogsCapabilities = JSON.parse(msg.body.msg);

      if (this.pkgProdLogsCapabilities.supportsLogsPackage && this.pkgProdLogsCapabilities.tasks && this.pkgProdLogsCapabilities.tasks.length > 0) {
        this.componentTableRows.forEach((row: DataTableRow) => {
          let menu: ActionMenuItem[] = row.actions.filter((action: ActionMenuItem) => {
            return action.id == "downloadLogPackages";
          });

          if (menu.length == 0) {
            row.actions.push(new ActionMenuItem("downloadLogPackages", $localize`Download Logs Packages`, ActionMenuIcon.DOWNLOAD, undefined, false));
            row.actions.push(new ActionMenuItem("createLogPackages", $localize`Create a Logs Package`, ActionMenuIcon.ADD, row.data, true));
          }
        });
      }

      this.recountSelectedRow = !this.recountSelectedRow;
    }
    this.setLoading();
  }

  processEnableProductCapabilities(msg: MsgPayLoad): void {
    this.enableCapabilities = this.activityCapabilities;
    if (this.activityCapabilityTarget == EVENT_TARGET.ANALYZE_PRIMARY_SYSTEM) {
      this.activityCapabilities.tasks.forEach((task: ActivityTask) => {
        //set validate host task to success
        if (task.type == ActivityTaskType.VALIDATE_HOST) {
          task.completed = true;
          task.success = true;
          task.isCurrentTask = false;
          //set validate comm task to success and current task
        } else if (task.type == ActivityTaskType.VALIDATE_COMMUNICATIONS) {
          task.completed = true;
          task.success = true;
          task.isCurrentTask = true;
        } else {
          task.isCurrentTask = false;
        }
      });

      this.analyzeMasterSystem(this.solutionInfo, this.activityCapabilities, this.activeProduct);
      this.isReload = true;
    } else if (this.activityCapabilityTarget == EVENT_TARGET.UPDATE_PRIMARY_SYSTEM) {
      let validateCommunications: boolean = false;
      for (let i = 0; i < this.activityCapabilities.tasks.length; i++) {
        if (this.activityCapabilities.tasks[i].type == ActivityTaskType.VALIDATE_COMMUNICATIONS) {
          validateCommunications = true;
          break;
        }
      }

      if (validateCommunications) {
        //is updating primary system?
        let isUpdatingPrimarySystem: boolean = this.selectedSystem[0].isMasterInstance &&
          this.selectedSystem[0].instanceURL &&
          this.selectedSystem[0].instanceURL != '';
        let scheme: string = undefined;
        let port: string = undefined;
        let path: string = undefined;
        let host: string = this.selectedSystem[0].system;
        let dlgMsg: string = "";
        let dlgTitle: string = "";

        if (isUpdatingPrimarySystem) {
          try {
            let url: URL = new URL(this.selectedSystem[0].instanceURL);
            scheme = url.protocol + "//";
            host = url.hostname;
            port = url.port;
            path = url.pathname.substring(1);
            dlgMsg = $localize`In order to update the primary system, the communication must be verified. Enter the information below and click Authenticate to start the test.`;
            dlgTitle = $localize`Update primary system for '${this.activeProduct.name}'`;
          } catch (e) {
            console.error(e);
          }
        } else {
          dlgMsg = $localize`In order to change primary systems, the communication must be verified. Enter the information below and click Authenticate to start the test.`;
          dlgTitle = $localize`Change primary system for '${this.activeProduct.name}'`;
        }

        let modalConfig: EnableProductModalConfig = new EnableProductModalConfig({ systemName: host, macAddress: this.selectedSystem[0].macAddress },
          { plugin: this.activeProduct.pluginId, productName: this.activeProduct.name },
          this.enableCapabilities,
          this.solutionInfo,
          dlgMsg,
          false,
          dlgTitle,
          scheme,
          port,
          path);
        this.showLoginDialog(modalConfig);
      } else {
        this.showUpdatePrimaryAreYouSureDialog();
      }
    }
  }

  processAdminSettingsCapabilities(msg: MsgPayLoad): void {
    this.isAdminSettingsCapabilitiesReceived = true;
    //check if download log feature is supported
    if (this.activityCapabilities.ok) {
      this.componentTableRows.forEach((row: DataTableRow) => {
        if (!row.containsActionMenuItem("adminSettings")) {
          row.actions.push(new ActionMenuItem("adminSettings", $localize`Administration Settings`, ActionMenuIcon.UNREGISTER, row.data, true));
        }
      });
      this.adminSettingsCapabilities = JSON.parse(msg.body.msg);
      this.recountSelectedRow = !this.recountSelectedRow;
    }
    this.setLoading();
  }

  getProductDetails(): void {
    this.isProductDetailsInProgress = true;
    this.siService.getProductDetail(this.currEnvId, this.platform, this.productId).pipe(
      tap(resp => {
        this.activeProduct = resp.body;
        this.getAdditionalCapabilities();
        let foundComponents = this.activeProduct.components.filter((comp: ProductComponent) => { return comp.setupid === this.setupid });

        if (foundComponents.length > 0) {
          this.activeComponent = foundComponents[0];
          this.componentTableRows = [];
          this.title = $localize`${this.activeComponent.name} ${this.activeProduct.version} Component`;
          this.dataService.sendData({ type: ProductDataType.Title, title: this.title });
          this.dataService.sendData({
            type: ProductDataType.SelectTree, select: {
              type: ProductTreeType.COMPONENT,
              productGroupId: this.activeProduct.groupId,
              productId: this.productId,
              setupid: this.activeComponent.setupid
            }
          });
          this.activeProductInstances = {};

          for (let key in this.activeProduct.instances) {
            let foundInstances = this.activeProduct.instances[key].filter((instance: ProductInstance) => { return instance.setupId === this.setupid });
            if (foundInstances.length > 0) {
              this.activeProductInstances[key] = foundInstances;
            }
          }

        } else {
          this.router.navigate(['products/overview']);
        }
        this.isProductDetailsInProgress = false;
        this.processProductAgents();
      })
    ).subscribe();
  }

  processProductAgents(): void {
        this.componentTableRows = [];

        for (let key in this.activeProductInstances) {
          this.activeProductInstances[key].forEach((instance: ProductInstance) => {
            if (instance.isMasterInstance) {
              this.masterSystemCounter++;
            }

            let instanceAgent: Agent[] = this.solutionInfo.currentEnvironment.agents.filter((agent: Agent) => {
              return agent.macAddress == key;
            });

            if (instanceAgent.length > 0) {
              instance.agent = instanceAgent[0];
            }

            let actions: ActionMenuItem[] = [new ActionMenuItem("details", $localize`Details`, ActionMenuIcon.DETAILS, instance, false, true)];

            if (this.productCapabilities.supportsUpdateAnalysis) {
              actions.push(new ActionMenuItem("updateAnalysis", $localize`Update analysis`, ActionMenuIcon.EXECUTE, instance, true));
            }

            if (this.productCapabilities.supportsResync) {
              actions.push(new ActionMenuItem("resynchronize", $localize`Resynchronization`, ActionMenuIcon.RETRY, instance, true));
            }
            let agent = this.solutionInfo.currentEnvironment.agents.find((a: Agent) => a.macAddress == instance.macAddress);
            let instanceRow: ProductInstanceRow = new ProductInstanceRow(instance.installPath, instance.instanceURL, instance.isMasterInstance,
              instance.macAddress, instance.metadata, instance.platform,
              instance.status, instance.system, instance.version, instance.productGroupId,
              this.getMasterSystemStatus(instance.isMasterInstance),
              this.getAgentStatus(instance.agent),
              this.getInstanceStatus(instance.status), instance.setupId);
            let row: DataTableRow = new DataTableRow(instanceRow, actions, false, false, false,
              $localize`Change primary system to resolve the issue`);
            row.disableCheckbox = !agent.isOnline;
            this.componentTableRows.push(row);
          });
        }

        this.isMasterSystemSelected = this.productCapabilities.supportsCluster ? this.masterSystemCounter == 1 : true;

        if (this.productCapabilities.supportsCluster) {
          //make sure change master system menu is available
          this.componentTableRows.forEach(row => {
            if (this.activeProduct.isMultiComponent && this.activeProduct.includeAllComponentsAsInstances)
              if (!this.isMasterSystemSelected && this.productCapabilities.supportsCluster) {
                if (!this.activeProduct.isMultiComponent || (this.activeProduct.isMultiComponent && !this.activeProduct.includeAllComponentsAsInstances)) {
                  row.error = true;
                }
              }

            let metadata = JSON.parse(row.data.metadata);
            if (!metadata.isMultiComponent || (metadata.isMultiComponent && metadata.componentCanBePrimary)) {
              if (!this.isMasterSystemSelected) {
                row.disableCheckbox = false;
                row.actions.splice(1, 0, new ActionMenuItem("changeMasterSystem", $localize`Change Primary system`, ActionMenuIcon.SETTINGS, row.actions[0].data, false, true));
              } else {
                if (row.actions[0].data.isMasterInstance) {
                  row.actions.splice(1, 0, new ActionMenuItem("updateMasterSystem", $localize`Update Primary system`, ActionMenuIcon.SETTINGS, row.actions[0].data, false, true));
                } else {
                  row.disableCheckbox = this.isAgentOfflineByProductInstanceRow(row.data);
                  row.actions.splice(1, 0, new ActionMenuItem("changeMasterSystem", $localize`Change Primary system`, ActionMenuIcon.SETTINGS, row.actions[0].data, false, true));
                }
              }
            }
          });
        }

        this.setLoading();
  }

  getAdditionalCapabilities(): void {
    if (this.productCapabilities.supportsLogsPackage) {
      this.getProductLogsCapabilities(this.foundProduct.pluginId);
    } else {
      this.isPkgProdLogsCapabilitiesReceived = true;
    }
    if (this.productCapabilities.supportsAdminSettings) {
      this.getAdminSettingsCapabilities(this.foundProduct.pluginId);
    } else {
      this.isAdminSettingsCapabilitiesReceived = true;
    }
  }
  
  setSystemStatus():void {
    if(this.componentTableRows != undefined &&  this.componentTableRows.length > 0){
      this.componentTableRows.forEach((row: DataTableRow) => {
        let agent = this.solutionInfo.currentEnvironment.agents.find((a: Agent) => a.macAddress == row.data.macAddress);
        row.data.agentStatus = this.getAgentStatus(agent);
        row.disableCheckbox = !agent.isOnline;
      });
    }
  }

  actionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === "changeMasterSystem" || event.name === "updateMasterSystem"){
      this.selectedSystem = event.data;
      this.getEnableCapabilities(this.activeProduct.pluginId);
    }else if(event.name === "details"){
      this.openInstanceDialog(event.data[0]);
    }else if(event.name === "updateAnalysis"){
      this.router.navigate(['./ua'], { relativeTo: this.route.parent, state: { instances: event.data } });
    }else if(event.name === "resynchronize"){
      this.router.navigate(['./resync'], { relativeTo: this.route.parent, state: { instances: event.data } });
    }else if(event.name === "downloadLogPackages"){
      this.router.navigate(['/products/logsPackageDownloads']);
    }else if(event.name === "createLogPackages"){
      this.router.navigate(['./logsPackage'], { relativeTo: this.route.parent, state: { instances: event.data, capabilities: this.pkgProdLogsCapabilities,backURL: './' } });
    }else if(event.name === "adminSettings"){
      this.router.navigate(['./adminSettings'], { relativeTo: this.route.parent, state: { instances: event.data, capabilities: this.adminSettingsCapabilities,backURL: './' } });
    }
  }

  showLoginDialog(modalConfig: EnableProductModalConfig): void {
    const sub: Subscription =
      this.modal.open(EnableProductComponent, {
        data: modalConfig,
        id: 'otsc-products-set-mastersystem-dialog',
        height: '450px'
      }).afterClosed.subscribe((result: string) => {
        if (result) {
          this.siService.updateMasterSystem(this.selectedSystem[0].macAddress, this.selectedSystem[0].installPath,
            this.productId, this.solutionInfo.currentEnvironment.id,
            this.setupid, result).pipe(
              tap(resp => {
                let bannerMsg: MsgPayLoad;

                if (resp.body) {
                  bannerMsg = new MsgPayLoad(undefined, {
                    message: $localize`Primary system was updated.`
                  });
                  bannerMsg.eventType = Events.SuccessMsg;
                } else {
                  bannerMsg = new MsgPayLoad(undefined, {
                    message: $localize`An error occurred while updating the primary system. Please check the logs for more details.`
                  });
                  bannerMsg.eventType = Events.ErrorMsg;
                }

                Utils.addHeaderMessageBanner(this.eventService, bannerMsg);
                setTimeout(()=>{window.location.reload();}, 100);
              })
            ).subscribe();
        }
        sub.unsubscribe();
      });
  }

  goToResync():void {
    this.router.navigate(['./resync'], { relativeTo: this.route.parent });
  }

  goToUA():void {
    this.router.navigate(['./ua'], { relativeTo: this.route.parent });
  }

  analyzeMasterSystemClicked(): void {
    this.activityCapabilityTarget = EVENT_TARGET.ANALYZE_PRIMARY_SYSTEM;
    this.getEnableProductCapabilities(this.solutionInfo, this.activityCapabilities, this.activeProduct);
  }

  private getMasterSystemStatus(isMasterInstance:boolean): any {
    return isMasterInstance ? {className: 'otsc-icon-status-approve', altText: $localize`This instance is a primary system`} : {className: '', altText: ''};
  }

  private getInstanceStatus(isInstanceEnabled:boolean): any {
    return isInstanceEnabled ? $localize`Enabled` : $localize`Disabled`;
  }

  private getAgentStatus(agent:Agent): any {
    let agentStatus:any;

    if(agent == undefined){
      agentStatus = {className: 'otsc-icon-status-cancelled', altText: $localize`Agent is offline`};
    //disabled
    }else if(!agent.isActive){
      agentStatus = {className: 'otsc-icon-status-closed', altText: $localize`Agent is disabled`};
    //idle
    }else if(agent.isActive && agent.isOnline && !agent.isBusy){
      agentStatus = {className: 'otsc-icon-status-away', altText: $localize`Agent is idle`};
    //busy
    }else if(agent.isActive && agent.isOnline && agent.isBusy){
      agentStatus = {className: 'otsc-icon-status-busy', altText: $localize`Agent is busy`};
    //offline
    }else if(agent.isActive && !agent.isOnline){
      agentStatus = {className: 'otsc-icon-status-cancelled', altText: $localize`Agent is offline`};
    }

    return agentStatus;
  }

  private openInstanceDialog(instance: any): void{
    this.modal.open(InstanceDetailsComponent, {
      data: {
        instanceMetaData: JSON.parse(instance.metadata),
        productName: this.activeProduct.name + ' ' + this.activeProduct.version,
        supportHotfix: this.productCapabilities.supportsHotfix,
        id: 'otsc-products-set-mastersystem-dialog'
      }
    });
  }

  private rowClick(event: any): void{
    if(event.actions.length == 1) {
      this.openInstanceDialog(event.data);
    }
  }

  canDeactivate() : boolean{
    return !this.isLoading;
  }
  
  getDeactivateModalMessageConfig(): ModalConfig {
    let deactivationModalMsg: ModalConfig = {
                  data: {
                        title: $localize`Warning`,
                        message: $localize`Please wait while data is loading...`,
                        primaryBtn: $localize`Wait`,
                        secondaryBtn: $localize`Leave`,
                        width: '400px',
                        type: ModalMessageType.Warning,
                  },
                  id: 'otsc-product-comp-details-loading-warning',
                  closeOnESCKeyUp: false
            }
    return deactivationModalMsg;
  }

  getProductCapabilities(plugin: string): void {
    if(!this.productCapabilitiesRequestInProgress && this.productCapabilities == undefined){ 
      this.productCapabilitiesRequestInProgress = true;
      this.siService.sendActivityCapabilities(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
      new ActivityCapabilitiesRequest(-1, ActivityCapabilitiesType.PRODUCT_CAPABILITIES, plugin, '')).pipe(
      tap(resp => {
      }),
      catchError(resp => {
        Utils.addTaskErrorHeaderMessageEventBanner(this.eventService, "ACTIVITY_CAPABILITIES", undefined);
        this.isLoading = false;
        return of(resp);
      })).subscribe();
    }
  }

  getEnableCapabilities(plugin: string): void {
    this.activityCapabilityTarget = EVENT_TARGET.UPDATE_PRIMARY_SYSTEM;
    this.siService.sendActivityCapabilities(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
      new ActivityCapabilitiesRequest(-1, 'ENABLE_PRODUCT', plugin, '')).pipe(
    tap(resp => {
    }),
    catchError(resp => {
      Utils.addTaskErrorHeaderMessageEventBanner(this.eventService, "ACTIVITY_CAPABILITIES", undefined);
      return of(resp);
    })).subscribe();
  }

  getAdminSettingsCapabilities(plugin: string): void {
    this.siService.sendActivityCapabilities(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
    new ActivityCapabilitiesRequest(-1, ActivityCapabilitiesType.ADMIN_SETTINGS, plugin, '')).pipe(
    tap(resp => {
    }),
    catchError(resp => {
      Utils.addTaskErrorHeaderMessageEventBanner(this.eventService, "ACTIVITY_CAPABILITIES", undefined);
      return of(resp);
    })).subscribe();
  }

  getProductLogsCapabilities(plugin: string): void {
    this.siService.sendActivityCapabilities(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
    new ActivityCapabilitiesRequest(-1, ActivityCapabilitiesType.PACKAGE_PRODUCT_LOGS, plugin, this.setupid,
      this.activeProduct.groupId
    )).pipe(
    tap(resp => {
    }),
    catchError(resp => {
      Utils.addTaskErrorHeaderMessageEventBanner(this.eventService, "ACTIVITY_CAPABILITIES", undefined);
      return of(resp);
    })).subscribe();
  }

  resetDefaults(): void {
    this.productCapabilities = undefined;
    this.adminSettingsCapabilities = undefined;
    this.pkgProdLogsCapabilities = undefined;
    this.isActivityCapabilitiesRequsted = false;
    this.isPkgProdLogsCapabilitiesReceived = false;
    this.isAdminSettingsCapabilitiesReceived = false;
    this.quickAnalysisResult = undefined;
    this.foundProduct = undefined;
    this.componentTableRows = [];
    this.masterSystemCounter = 0;
  }

  setLoading(): void {
    this.isLoading = this.productCapabilities == undefined || !this.isPkgProdLogsCapabilitiesReceived 
    || !this.isAdminSettingsCapabilitiesReceived || this.isManifestUpdating || this.isAgentManifestUpdating;
  }

  isAgentOfflineByProductInstanceRow(data:ProductInstanceRow):boolean {
    return data.agentStatus.className === 'otsc-icon-status-cancelled';
  }

  showUpdatePrimaryAreYouSureDialog(): void {
    const sub: Subscription =
    this.modal.open(ModalMessageComponent, {
      data: {
        title: $localize`Change primary system`,
        message: $localize`Are you sure you want to change your primary system?`,
        type: ModalMessageType.Question,
        primaryBtn: $localize`Yes`,
        secondaryBtn: $localize`No`,
        width: '475px'
      },
      id: 'otsc-change-primary-sure-dlg'
    }
    ).afterClosed.subscribe((result: boolean) => {
      if (result) {
        this.siService.updateMasterSystem(this.selectedSystem[0].macAddress, this.selectedSystem[0].installPath,
          this.productId, this.solutionInfo.currentEnvironment.id,
          this.setupid, '').pipe(
            tap(resp => {
              let bannerMsg: MsgPayLoad;

              if (resp.body) {
                bannerMsg = new MsgPayLoad(undefined, {
                  message: $localize`Primary system was updated.`
                });
                bannerMsg.eventType = Events.SuccessMsg;
              } else {
                bannerMsg = new MsgPayLoad(undefined, {
                  message: $localize`An error occurred while updating the primary system. Please check the logs for more details.`
                });
                bannerMsg.eventType = Events.ErrorMsg;
              }

              Utils.addHeaderMessageBanner(this.eventService, bannerMsg);
              setTimeout(()=>{window.location.reload();}, 100);
            })
          ).subscribe();
      }
      sub.unsubscribe();
    });
  }
}